import React from 'react';
import { useState } from 'react';
import {
  DeleteButton,
  SaveButton,
  SignOut,
  UndoButton,
} from '../../utility/component/buttons';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCompanyAddress,
  selectEmail,
  selectISFirebaseSocketOn,
  selectUserType,
} from '../../utility/Redux/profile';
import CryptoJS from 'crypto-js';
import axios from 'axios';
import { useEffect } from 'react';
import {
  setAlertWithTitle,
  setListStationMasterModalStatus,
  setModCompanyHelpStatus,
  setSpinnerLoading,
} from '../../utility/Redux/modal';
import ModListStationMaster from '../../utility/component/modals/modListStationMaster';
import GeniustextInput from '../../utility/component/mastertext';
import { useRef } from 'react';
import ModalHeaderStyle from '../../utility/component/styles/modalHeader';
import { useNavigate } from 'react-router-dom';
import ModUserHelp from '../../utility/component/modals/modUserHelp';
import ModCompanyHelp from '../../utility/component/modals/modCompanyHelp';
import CallAPI from '../../utility/functions/getData';
import { selectToken } from '../../utility/Redux/security';
import AlertModalTwoButton from '../../utility/component/modals/alertWithTwoButton';
import { ref, set } from 'firebase/database';
import database from '../issueStock/firebase';
import { CallAPIPromise } from './dashboard/biiling/modal/comman';
import { toProperCase } from '../../utility/component/format';
import { PAGE_ACCESS_OPTIONS, parseAllowedPages } from '../../utility/pageAccess';

const UserMaster = () => {
  const [selectedUserType, setSelectedUserType] = useState('USER');
  const [companyInfo, setCompanyInfo] = useState('');
  const [SID, setSID] = useState(0);
  const [sName, setSname] = useState('');
  const [userInfoStatus, setUserInfoStatus] = useState(false);
  const [selectedUserStatus, setSelectedUserStatus] = useState('ACTIVE');
  const [userCode, setUserCode] = useState('');
  const headerRef = useRef();
  const [scopesList, setScopeList] = useState([]);

  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: '',
    msg: '',
    status: false,
    setStatus: '',
    button1: '',
    button1Click: '',
    button2: '',
    button2Click: '',
  });

  const emptyUserDetails = {
    user_email: '',
    user_password: '',
    user_name: '',
    user_mobile: '',
    user_type: selectedUserType,
    user_status: selectedUserStatus,
    company_email: '',
    company_name: '',
    company_mobile: '',
    company_website: '',
    company_logo: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pin_code: '',
    current_name: '',
    currency_symbol: '',
    regd_no1: '',
    regd_no2: '',
    regd_no3: '',
    disputes: '',
    user_scope: [],
    allowed_pages: [],
  };
  const [userDetails, setUserDetails] = useState(emptyUserDetails);
  const isFirebaseSocketOn = useSelector(selectISFirebaseSocketOn);
  const [confirmPaswrd, setConfirmPaswrd] = useState('');
  const userEmail = useSelector(selectEmail);
  const [isUSersLimitComplete, setIsUserLimitComplete] = useState(false);

  const companyDetail = useSelector(selectCompanyAddress);
  const dispatch = useDispatch();
  const userType = useSelector(selectUserType);
  const CompanyUserInfo = () => {
    const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;
    const email = companyDetail.email;
    const hmac = CryptoJS.HmacSHA256(email, secretPass);

    const hmacString = hmac.toString(CryptoJS.enc.Base64);
    const data = {
      company_email: companyDetail.email,
      user_email: phoneRegex.test(userEmail) ? '' : userEmail,
      user_mobile: phoneRegex.test(userEmail) ? userEmail : '',
    };
    CallAPIPromise(`/api/users/userCompanyInfo`, data, hmacString, dispatch)
      .then(async function (response) {
        setCompanyInfo(response.data[0]);
        if (response.data[0].no_of_users - response.data[0].TOTAL_USERS > 0) {
          setIsUserLimitComplete(false);
        } else {
          setIsUserLimitComplete(true);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;
  const token = useSelector(selectToken);
  const saveUser = () => {
    if (!isUSersLimitComplete || userCode) {
      if (
        (userDetails.user_mobile && phoneRegex.test(userDetails.user_mobile)) ||
        !userDetails.user_mobile
      ) {
        if (
          userDetails.user_email ||
          (userDetails.user_mobile && userDetails.user_name)
        ) {
          if (userDetails.user_password === confirmPaswrd) {
            if (
              userDetails.user_password
                ? userDetails.user_password.length > 5
                : true
            ) {
              const email = userDetails.user_email;
              // const hmac = CryptoJS.HmacSHA256(message, secret);
              const hmac = CryptoJS.HmacSHA256(email, secretPass);
              // Convert the HMAC to a string and encode it using Base64
              const hmacString = hmac.toString(CryptoJS.enc.Base64);
              const companyName = companyInfo.company_name;
              const words = companyName.split(' ');
              const p =
                words.reduce((acc, word) => {
                  if (word) {
                    acc += word[0];
                  }
                  return acc;
                }, '') + '_';

              const data = {
                ...userDetails,

                company_email: companyInfo.company_email,
                company_website: companyInfo.company_website,
                company_name: companyInfo.company_name,
                company_mobile: companyInfo.company_mobile,
                address: companyInfo.address,
                city: companyInfo.city,
                state: companyInfo.state,
                pin_code: companyInfo.pin_code,
                station_id: SID,
                station_name: sName,
                currency_name: companyInfo.currency_name,
                currency_symbol: companyInfo.currency_symbol,
                regd_no1: companyInfo.regd_no1,
                regd_no2: companyInfo.regd_no2,
                regd_no3: companyInfo.regd_no3,
                message_send_through:companyInfo.message_send_through||"SMS",
                disputes: companyInfo.disputes,
                company_logo: '',
                table_prefix: p.toLowerCase(),
                activate_code: companyInfo.activate_code,
                code: userCode,
                user_role: toProperCase(selectedUserType.toLowerCase()),
                user_scope: userDetails.user_scope.join(','),
                allowed_pages: userDetails.allowed_pages.join(','),
              };
              dispatch(setSpinnerLoading('Creating'));
              CallAPIPromise(
                `/api/users/createNewUser`,
                data,
                hmacString,
                dispatch
              )
                .then(async function async(response) {
                  if (response.status === 200) {
                    if (userDetails.user_email || userCode) {
                      dispatch(
                        setAlertWithTitle({
                          title: 'Success',
                          msg: userCode
                            ? 'User Modified'
                            : 'User created check email for verify account.',
                        })
                      );
                      undo();
                    }
                    if (
                      !userDetails.user_email &&
                      userDetails.user_mobile &&
                      !userCode
                    ) {
                      emailVerified(
                        userDetails.user_mobile,
                        companyInfo.activate_code,
                        userDetails.user_name
                      );
                    }
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  dispatch(setSpinnerLoading(false));
                });
            } else {
              dispatch(
                setAlertWithTitle({
                  title: 'Password Error',
                  msg: 'Password length must be more then 5 digits.',
                })
              );
            }
          } else {
            dispatch(
              setAlertWithTitle({
                title: 'Error ',
                msg: 'Password and Confirm Password must be same.',
              })
            );
          }
        } else {
          dispatch(
            setAlertWithTitle({
              title: 'Error',
              msg: 'Fill All Fields',
            })
          );
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: 'Error',
            msg: 'Invalid mobile',
          })
        );
      }
    } else {
      dispatch(
        setAlertWithTitle({
          title: 'Alert',
          msg: 'Users limit crossed',
        })
      );
    }
  };

  const undo = () => {
    setUserDetails(emptyUserDetails);
    setConfirmPaswrd('');
    setUserCode('');

    setSname('');
    setSID(0);
    setSelectedUserType('USER');
    setSelectedUserStatus('ACTIVE');
    dispatch(setSpinnerLoading(false));
  };

  useEffect(() => {
    CompanyUserInfo();
  }, []);

  const emailVerified = (mobile, activationCode, userName) => {
    const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;

    // const hmac = CryptoJS.HmacSHA256(message, secret);
    const hmac = CryptoJS.HmacSHA256(mobile, secretPass);
    // Convert the HMAC to a string and encode it using Base64
    const hmacString = hmac.toString(CryptoJS.enc.Base64);
    const data = {
      user_email: '',
      user_mobile: mobile,
    };
    dispatch(setSpinnerLoading('Verify User'));
    CallAPIPromise('/api/users/emailVerified', data, hmacString, dispatch)
      .then((res) => {
        if (!res.data.error) {
          sendEmailToAdmin(hmacString, mobile, activationCode, userName);
        } else {
          dispatch(setSpinnerLoading(false));
          dispatch(
            setAlertWithTitle({
              title: 'Alert',
              msg: 'Something went wrong',
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(setSpinnerLoading(false));
      });
  };

  const sendEmailToAdmin = (hmacString, mobile, activationCode, userName) => {
    const data = {
      user_email: '',
      user_name: userName,
      activate_code: activationCode,
      user_mobile: mobile,
    };
    dispatch(setSpinnerLoading('Sending Email to admin'));

    CallAPIPromise('/api/users/sendEmailToAdmin', data, hmacString, dispatch)
      .then((res) => {
        dispatch(
          setAlertWithTitle({
            title: 'Success',
            msg: 'User created Successfully.',
            lottie: 'success',
          })
        );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        undo();
        dispatch(setSpinnerLoading(false));
      });
  };

  const phoneRegex = /^[6-9]\d{9}$/;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const navigate = useNavigate();

  const CheckUserInfo = () => {
    const userEmail = emailRegex.test(userDetails.user_email)
      ? userDetails.user_email
      : '';
    const userMobile = phoneRegex.test(userDetails.user_mobile)
      ? userDetails.user_mobile
      : '';

    const user = userEmail ? userEmail : userMobile;
    const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;

    // const hmac = CryptoJS.HmacSHA256(message, secret);
    const hmac = CryptoJS.HmacSHA256(user, secretPass);
    // Convert the HMAC to a string and encode it using Base64
    const hmacString = hmac.toString(CryptoJS.enc.Base64);
    const data = {
      user_email: userEmail ? userEmail : '',
      user_mobile: !userEmail ? userMobile : '',
    };
    CallAPIPromise(`/api/users/userInfo`, data, hmacString, dispatch)
      .then(async function (response) {
        if (response.data.response[0]) {
          dispatch(
            setAlertWithTitle({
              title: 'Alert',
              msg: 'User allready registered with same id',
            })
          );
          setUserDetails({
            ...userDetails,
            user_mobile: '',
            user_email: '',
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!userCode) {
      if (userDetails.user_mobile || userDetails.user_email) {
        CheckUserInfo();
      }
    }
  }, [userDetails.user_mobile, userDetails.user_email]);

  const UserTypeOption =
    userType === 'ADMIN'
      ? [
          {
            name: 'USER',
            value: 'USER',
          },
          {
            name: 'STORE',
            value: 'STORE',
          },
          {
            name: 'MANAGER',
            value: 'MANAGER',
          },
          {
            name: 'ADMIN',
            value: 'ADMIN',
          },
          {
            name: 'MANUFACTURING',
            value: 'MANUFACTURING',
          },
        ]
      : [
          {
            name: 'USER',
            value: 'USER',
          },
          {
            name: 'STORE',
            value: 'STORE',
          },
          {
            name: 'MANAGER',
            value: 'MANAGER',
          },
          {
            name: 'MANUFACTURING',
            value: 'MANUFACTURING',
          },
        ];
  const deleteUser = () => {
    dispatch(setSpinnerLoading('Deleting'));
    CallAPI(
      '/api/users/deleteUser',
      {
        company_email: companyInfo.company_email,
        user_email: userDetails.user_email,
        user_mobile: userDetails.user_email ? '' : userDetails.user_mobile,
      },
      token,
      () => {
        dispatch(
          setAlertWithTitle({
            title: 'Success',
            msg: 'User deleted successfully',
          })
        );
        undo();
      },
      dispatch,
      () => {
        dispatch(setSpinnerLoading(false));
      }
    );
  };

  const getScopeList = () => {
    CallAPIPromise('/api/userSettings/listScope', {}, token, dispatch).then(
      (res) => {
        if (!res.data.error) {
          const optionList = res.data.response.map((s) => {
            return {
              name: s.USER_SCOPE,
              value: s.USER_SCOPE,
            };
          });

          setScopeList(optionList);
        }
      }
    );
  };

  useEffect(() => {
    getScopeList();
  }, []);

  const allPagePaths = PAGE_ACCESS_OPTIONS.flatMap((group) =>
    group.pages.map((page) => page.path)
  );
  const allowedPageCount = userDetails?.allowed_pages?.length;
  const isAllPagesAllowed = allowedPageCount === allPagePaths.length;

  return (
    <div className="w-full flex justify-center  bg-gray-50 h-full  p-3">
      <div className="text-sm  rounded-sm  h-full overflow-hidden">
        <div ref={headerRef} className="bg-white   ">
          <ModalHeaderStyle
            header={'User Master'}
            onClose={() => navigate('/settings')}
          />
        </div>
        <div
          style={{
            height: headerRef.current
              ? `calc(100% - ${headerRef.current.clientHeight}px)`
              : '90%',
          }}
          className="      flex flex-col "
        >
          <div className="overflow-y-scroll py-3 px- p-3  bg-white   pr-3">
            {userType === 'ADMIN' && (
              <div className="flex ">
                <GeniustextInput
                  type={'text'}
                  titleBold={true}
                  titleColor={'#383535'}
                  title={'Comapny Name'}
                  search={() => {
                    dispatch(setModCompanyHelpStatus(true));
                  }}
                  width={'270px'}
                  value={userDetails.company_name}
                  error={false}
                />
              </div>
            )}{' '}
            <div className="grid grid-cols-1 gap-2 ll:grid-cols-2">
              <div className="flex  ">
                <GeniustextInput
                  search={() => {
                    setUserInfoStatus(true);
                  }}
                  value={userDetails.user_name}
                  onChange={(t) => {
                    setUserDetails({
                      ...userDetails,
                      user_name: t.target.value,
                    });
                  }}
                  type={'text'}
                  title={'User Name'}
                  width={'270px'}
                  error={false}
                />
              </div>

              <div className="flex  ">
                <GeniustextInput
                  width={'270px'}
                  type={'text'}
                  title={'Email'}
                  value={userDetails.user_email}
                  onChange={(t) => {
                    setUserDetails({
                      ...userDetails,
                      user_email: t.target.value,
                    });
                  }}
                  error={
                    userDetails.user_email
                      ? emailRegex.test(userDetails.user_email)
                        ? false
                        : 'Invalid email'
                      : false
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-1 gap-2 ll:grid-cols-2">
              <div className="flex">
                <GeniustextInput
                  type={'number'}
                  width={'270px'}
                  title={'Mobile'}
                  value={userDetails.user_mobile}
                  onChange={(t) => {
                    setUserDetails({
                      ...userDetails,
                      user_mobile: t.target.value,
                    });
                  }}
                  error={
                    userDetails.user_mobile
                      ? phoneRegex.test(userDetails.user_mobile)
                        ? false
                        : 'Invalid mobile'
                      : false
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-1 gap-2 ll:grid-cols-2">
              {!userCode ? (
                <>
                  <div className="flex">
                    <GeniustextInput
                      type={'password'}
                      width={'270px'}
                      title={'Password'}
                      value={userDetails.user_password}
                      error={
                        userDetails.user_password
                          ? userDetails.user_password.length > 5
                            ? false
                            : 'Passwords must be at least 6 characters.'
                          : false
                      }
                      onChange={(t) => {
                        setUserDetails({
                          ...userDetails,
                          user_password: t.target.value,
                        });
                      }}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="flex">
                    <GeniustextInput
                      type={'password'}
                      width={'270px'}
                      title={'Password'}
                      onFocus={(e) => {
                        e.currentTarget.select();
                      }}
                      value={userDetails.user_password}
                      onChange={(t) => {
                        setUserDetails({
                          ...userDetails,
                          user_password: t.target.value,
                        });
                      }}
                      error={false}
                    />
                  </div>
                </>
              )}
              {!userCode ? (
                <>
                  <div className="flex">
                    <GeniustextInput
                      width={'270px'}
                      type={'password'}
                      value={confirmPaswrd}
                      onChange={(t) => {
                        setConfirmPaswrd(t.target.value);
                      }}
                      title={'Confirm Password'}
                      error={
                        confirmPaswrd
                          ? userDetails.user_password === confirmPaswrd
                            ? false
                            : 'Passwords must be same.'
                          : false
                      }
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className=" flex ">
                    <GeniustextInput
                      width={'270px'}
                      type={'password'}
                      onFocus={(e) => {
                        e.currentTarget.select();
                      }}
                      // value={confirmPaswrd ? confirmPaswrd : oldPaswrd}
                      onChange={(t) => {
                        setConfirmPaswrd(t.target.value);
                      }}
                      title={'Confirm Password'}
                      error={
                        confirmPaswrd
                          ? confirmPaswrd !== userDetails.user_password
                            ? 'Password must be same.'
                            : false
                          : false
                      }
                    />
                  </div>
                </>
              )}
            </div>
            <div className="grid grid-cols-1 gap-2 ll:grid-cols-2">
              <div className=" flex ">
                <GeniustextInput
                  type={'number'}
                  search={() => {
                    dispatch(setListStationMasterModalStatus(true));
                  }}
                  title={'Station Id'}
                  width={'270px'}
                  value={SID}
                  onChange={(e) => {
                    setSID(e.target.value);
                  }}
                  error={false}
                />
              </div>
              <div className="flex ">
                <GeniustextInput
                  type={'text'}
                  title={'Station Name'}
                  width={'270px'}
                  onChange={(e) => {
                    setSname(e.target.value);
                  }}
                  value={sName}
                  error={false}
                />
              </div>
            </div>
            <div className="mt-2 flex justify-between ">
              {' '}
              <div className="flex">
                <GeniustextInput
                  option={UserTypeOption}
                  width={'100px'}
                  value={selectedUserType}
                  onChange={(e) => {
                    setSelectedUserType(e.target.value);
                    setUserDetails({
                      ...userDetails,
                      user_type: e.target.value,
                    });
                  }}
                  title={'User Type'}
                />
                <div className="ml-2">
                  <GeniustextInput
                    option={[
                      {
                        name: 'ACTIVE',
                      },
                      {
                        name: 'PENDING',
                      },
                    ]}
                    onChange={(e) => {
                      setSelectedUserStatus(e.target.value);
                      setUserDetails({
                        ...userDetails,
                        user_status: e.target.value,
                      });
                    }}
                    value={selectedUserStatus}
                    title={'User Status'}
                    width={'100px'}
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center">
              <div>Have Access</div>
              <input
                className="ml-1"
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setUserDetails((o) => {
                      return {
                        ...o,
                        user_scope: scopesList.map((sc) => sc.value),
                      };
                    });
                  } else {
                    setUserDetails((o) => {
                      return {
                        ...o,
                        user_scope: [],
                      };
                    });
                  }
                }}
              />
            </div>
            <div className=" w-full border p-2  ">
              <div className="grid grid-cols-1 t:grid-cols-2 gap-2 w-full mt-1 ">
                {scopesList.map((s) => {
                  const isAvailvel = userDetails.user_scope.filter(
                    (scopes) => scopes === s.value
                  );
                  return (
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={isAvailvel[0] ? true : false}
                        onChange={(e) => {
                          let currentScopeList = userDetails.user_scope;

                          if (e.target.checked) {
                            setUserDetails((u) => {
                              currentScopeList.push(s.value);
                              return {
                                ...u,
                                user_scope: currentScopeList,
                              };
                            });
                          } else {
                            const data = currentScopeList.filter(
                              (c) => c !== s.value
                            );

                            setUserDetails((u) => {
                              return {
                                ...u,
                                user_scope: data,
                              };
                            });
                          }
                        }}
                      />
                      <div className="ml-1 text-[15px] font-semibold">
                        {s.name}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {userType === 'ADMIN' && (
              <div className="w-full border border-gray-200 rounded-sm mt-4 overflow-hidden">
                <div className="bg-[#f2f2ef] px-3 py-3 flex flex-col t:flex-row t:items-center t:justify-between gap-2">
                  <div>
                    <div className="text-[18px] font-bold text-[#302d2d]">
                      Allowed Pages
                    </div>
                    <div className="text-xs text-gray-600 mt-1">
                      {allowedPageCount} of {allPagePaths.length} pages selected
                    </div>
                  </div>
                  <label className="flex items-center gap-2 text-sm font-semibold text-[#302d2d] cursor-pointer">
                    <input
                      type="checkbox"
                      checked={isAllPagesAllowed}
                      onChange={(e) => {
                        setUserDetails((u) => {
                          return {
                            ...u,
                            allowed_pages: e.target.checked ? allPagePaths : [],
                          };
                        });
                      }}
                    />
                    Allow all pages
                  </label>
                </div>
                <div className="w-full p-3 bg-white">
                  {PAGE_ACCESS_OPTIONS.map((group) => (
                    <div key={group.group} className="mb-4 last:mb-0">
                      <div
                        className="flex items-center justify-between border-b border-gray-200 pb-1 cursor-pointer"
                        onClick={() => {
                          const groupPaths = group.pages.map(
                            (page) => page.path
                          );
                          const isGroupAllowed = groupPaths.every((path) =>
                            userDetails.allowed_pages.includes(path)
                          );

                          setUserDetails((u) => {
                            return {
                              ...u,
                              allowed_pages: isGroupAllowed
                                ? u.allowed_pages.filter(
                                    (path) => !groupPaths.includes(path)
                                  )
                                : [...new Set([...u.allowed_pages, ...groupPaths])],
                            };
                          });
                        }}
                      >
                        <div className="text-[15px] font-bold text-gray-800">
                          {group.group}
                        </div>
                        <div className="flex items-center gap-2 text-xs font-semibold text-gray-700">
                          <span>Select group</span>
                          <input
                            type="checkbox"
                            readOnly
                            checked={group.pages.every((page) =>
                              userDetails?.allowed_pages?.includes(page.path)
                            )}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 t:grid-cols-2 ll:grid-cols-3 gap-2 w-full mt-2">
                        {group.pages.map((page) => {
                          const checked = userDetails?.allowed_pages?.includes(
                            page.path
                          );

                          return (
                            <label
                              key={page.path}
                              className={`flex items-center gap-2 px-2 py-2 rounded-sm border cursor-pointer ${
                                checked
                                  ? 'border-[#a8cf45] bg-[#f6fbe9]'
                                  : 'border-gray-200 bg-white'
                              }`}
                            >
                              <input
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => {
                                  setUserDetails((u) => {
                                    return {
                                      ...u,
                                      allowed_pages: e.target.checked
                                        ? [
                                            ...new Set([
                                              ...u.allowed_pages,
                                              page.path,
                                            ]),
                                          ]
                                        : u.allowed_pages.filter(
                                            (path) => path !== page.path
                                          ),
                                    };
                                  });
                                }}
                              />
                              <div className="text-[14px] font-semibold text-[#302d2d]">
                                {page.name}
                              </div>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="w-full flex justify-end p-3 rounded-b-sm bg-white">
            {(userCode && isFirebaseSocketOn && userType === 'ADMIN') ||
              (userCode && isFirebaseSocketOn && userType === 'MANAGER' && (
                <div className="mr-1">
                  {' '}
                  <SignOut
                    onClick={() => {
                      if (companyInfo.table_prefix) {
                        const setConnectRef = ref(
                          database,
                          `${companyInfo.table_prefix}/user/${userCode}/status/connection`
                        );
                        if (selectedUserType === 'MANAGER') {
                          const set2ConnectRef = ref(
                            database,
                            `${companyInfo.table_prefix}/user/${userCode}/status2/connection`
                          );
                          const set3ConnectRef = ref(
                            database,
                            `${companyInfo.table_prefix}/user/${userCode}/status3/connection`
                          );
                          set(set3ConnectRef, 'd');

                          set(set2ConnectRef, 'd');
                        }

                        set(setConnectRef, 'd');
                        dispatch(
                          setAlertWithTitle({
                            title: 'Alert',
                            msg: 'User Signout from all device',
                          })
                        );
                      } else {
                        dispatch(
                          setAlertWithTitle({
                            title: 'Alert',
                            msg: 'Table prefix not found',
                          })
                        );
                      }
                    }}
                  />{' '}
                </div>
              ))}
            {userCode && userType === 'ADMIN' && (
              <div className="mr-1">
                {' '}
                <DeleteButton
                  onClick={() => {
                    setAlertTwoButtonModal({
                      ...alertTwoButtonModal,
                      status: true,
                      title: 'Alert',
                      msg: 'Do you really want to delete this user?',
                      button1: 'Yes',
                      button2: 'Cancel',

                      button1Click: () => {
                        deleteUser();
                        setAlertTwoButtonModal({
                          ...alertTwoButtonModal,
                          status: false,
                        });
                      },
                      button2Click: () => {
                        setAlertTwoButtonModal({
                          ...alertTwoButtonModal,
                          status: false,
                        });
                      },
                    });
                  }}
                />{' '}
              </div>
            )}

            <SaveButton onClick={saveUser} />

            <UndoButton onClick={undo} />
          </div>
        </div>

        <ModUserHelp
          onRowClick={(params) => {
            setUserInfoStatus(false);
            const scops = params.row.USER_SCOPE;
            console.log(scops);
            setUserDetails({
              user_email: params.row.USER_EMAIL,
              user_password: '',
              user_name: params.row.USER_NAME,
              user_mobile: params.row.USER_MOBILE,
              user_type: params.row.USER_TYPE,
              user_status: params.row.USER_STATUS,
              company_name: params.row.COMPANY_NAME,
              user_scope: scops ? scops.split(',') : [],
              allowed_pages: parseAllowedPages(
                params.row.ALLOWED_PAGES || params.row.allowed_pages
              ),
            });

            setUserCode(params.row.CODE);
            setSID(params.row.STATION_ID);
            setSname(params.row.STATION_NAME);
            setSelectedUserStatus(params.row.USER_STATUS);
            setSelectedUserType(params.row.USER_TYPE);
          }}
          comapany={{
            companyEmail: companyInfo.company_email,
            userEmail: companyInfo.userEmail,
          }}
          onClose={() => {
            setUserInfoStatus(false);
          }}
          status={userInfoStatus}
          setStatus={setUserInfoStatus}
        />
        <ModListStationMaster
          onRowClick={(p) => {
            setSID(p.row.CODE);
            setSname(p.row.STATION_NAME);
            dispatch(setListStationMasterModalStatus(false));
          }}
        />
      </div>
      <ModCompanyHelp
        onRowClick={(p) => {
          setCompanyInfo({
            company_email: p.row.company_email,
            company_website: p.row.company_website,
            company_name: p.row.company_name,
            company_mobile: p.row.company_mobile,
            address: p.row.address,
            city: p.row.city,
            state: p.row.state,
            currency_name: p.row.currency_name,
            currency_symbol: p.row.currency_symbol,
            disputes: p.row.disputes,
            pin_code: p.row.pin_code,
            regd_no1: p.row.regd_no1,
            regd_no2: p.row.regd_no2,
            regd_no3: p.row.regd_no3,
            activate_code: p.row.activate_code,
            table_prefix: p.row.table_prefix,
            userEmail: p.row.user_email,
          });
          setUserDetails((u) => {
            return {
              ...emptyUserDetails,
              company_name: p.row.company_name,
              allowed_pages:p.row.allowed_pages
            };
          });
          dispatch(setModCompanyHelpStatus(false));
        }}
      />
      <AlertModalTwoButton
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />
    </div>
  );
};

export default UserMaster;
